var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "closings-table" },
    [
      _c(
        "SSRAgTable",
        _vm._g(
          {
            attrs: {
              frameworkComponents: _vm.frameworkComponents,
              columns: _vm.columnDefs,
              data: _vm.rowData,
              totalRows: _vm.totalRows,
              totalPages: _vm.totalPages,
              isLoading: _vm.isLoading,
              columnFilters: _vm.columnFilters,
              page: _vm.currentPage,
              isExportable: true,
              onExport: _vm.exportExcel,
            },
            on: {
              fetchData: _vm.getGridData,
              updateSelectedItems: _vm.onSelectedItems,
              searchQuery: function ($event) {
                _vm.searchQuery = $event
              },
            },
          },
          _vm.$listeners
        )
      ),
      _c("closings-details", {
        attrs: { modalActive: _vm.modalActive, modalData: _vm.detailModalData },
        on: {
          "update:modalActive": function ($event) {
            _vm.modalActive = $event
          },
          "update:modal-active": function ($event) {
            _vm.modalActive = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }